/*
MIT License

Copyright (c) 2023 Artem Churyukin

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

const _list=new Map();

function _add(uid,callback){
	if(typeof(uid)==='object'){
		for(let [i,c] of Object.entries(uid)) _add(i,c);
		return;
	}
	_list.set(uid,callback);
}

function _remove(uid){
	if(typeof(uid)!=='string'){
		if(uid instanceof Object){
			for(let i of Object.keys(uid)) _remove(i);
			return;
		} else if(uid instanceof Array){
			uid.forEach(_remove);
			return;
		}
	}
	_list.delete(uid);
}

function _handler(e){
	if(_ignore) return _ignore=false;
	let el=e.target;
	while(el&&el.dataset&&!el.dataset.action) el=el.parentNode;
	if(!el) return;
	if(!el.dataset||!el.dataset.action) return;
	if(!_list.has(el.dataset.action)) return;
	e.stopPropagation();
	e.preventDefault();
	let args=el.dataset.data;
	if(args){
		args=args.split(',').map(function(el){
			try{
				return JSON.parse(el);
			} catch(e){
				return el;
			}
		});
	} else {
		args=[];
	}
	_list.get(el.dataset.action)(e,...args);
	if(_blur_element){
		_possible_click=undefined;
		_blur_element.blur();
		_blur_element=undefined;
	}
	return false;
}

function _fire(action, e, ...args){
	if(action instanceof HTMLElement) return action.click();
	if(!_list.has(action)) return;
	_list.get(action)(e,...args);
}

let _possible_click;
let _blur_element;
let _ignore;

function _break(){
	_possible_click=false;
	_blur_element=false;
	_ignore=true;
}

window.addEventListener('click',_handler);
window.addEventListener('pointerdown',e=>{
	_possible_click=undefined;
	let el=e.target;
	while(el&&el.dataset&&!el.dataset.action) el=el.parentNode;
	if(!el) return;
	if(!el.dataset||!el.dataset.action) return;
	if(!_list.has(el.dataset.action)) return;
	_possible_click=el;
},true);
window.addEventListener('blur',e=>{
	if(!_possible_click) return;
	_blur_element=e.target;
	e.stopPropagation();
	e.preventDefault();
},true);
window.addEventListener('submit',_handler);

const _ext={
	add:_add,
	remove:_remove,
	fire:_fire,
	break:_break,
}

export default _ext
